// AUTO-GENERATED by tools/gen-enums.mjs -- do not edit by hand.
// Source: @meshtastic/protobufs 2.8.0
export const HARDWARE_NAMES = {
    0: "Unset",
    1: "Tlora V2",
    2: "Tlora V1",
    3: "Tlora V2 1 1p6",
    4: "Tbeam",
    5: "Heltec V2 0",
    6: "Tbeam V0p7",
    7: "T Echo",
    8: "Tlora V1 1p3",
    9: "Rak4631",
    10: "Heltec V2 1",
    11: "Heltec V1",
    12: "Lilygo Tbeam S3 Core",
    13: "Rak11200",
    14: "Nano G1",
    15: "Tlora V2 1 1p8",
    16: "Tlora T3 S3",
    17: "Nano G1 Explorer",
    18: "Nano G2 Ultra",
    19: "Lora Type",
    20: "Wiphone",
    21: "Wio Wm1110",
    22: "Rak2560",
    23: "Heltec Hru 3601",
    24: "Heltec Wireless Bridge",
    25: "Station G1",
    26: "Rak11310",
    27: "Makerfabs Tracker",
    28: "Makerfabs Reserved",
    29: "Canaryone",
    30: "Rp2040 Lora",
    31: "Station G2",
    32: "Lora Relay V1",
    33: "T Echo Plus",
    34: "Ppr",
    35: "Genieblocks",
    36: "Nrf52 Unknown",
    37: "Portduino",
    38: "Android Sim",
    39: "Diy V1",
    40: "Nrf52840 Pca10059",
    41: "Dr Dev",
    42: "M5stack",
    43: "Heltec V3",
    44: "Heltec Wsl V3",
    45: "Betafpv 2400 Tx",
    46: "Betafpv 900 Nano Tx",
    47: "Rpi Pico",
    48: "Heltec Wireless Tracker",
    49: "Heltec Wireless Paper",
    50: "T Deck",
    51: "T Watch S3",
    52: "Picomputer S3",
    53: "Heltec Ht62",
    54: "Ebyte Esp32 S3",
    55: "Esp32 S3 Pico",
    56: "Chatter 2",
    57: "Heltec Wireless Paper V1 0",
    58: "Heltec Wireless Tracker V1 0",
    59: "Unphone",
    60: "Td Lorac",
    61: "Cdebyte Eora S3",
    62: "Twc Mesh V4",
    63: "Nrf52 Promicro Diy",
    64: "Radiomaster 900 Bandit Nano",
    65: "Heltec Capsule Sensor V3",
    66: "Heltec Vision Master T190",
    67: "Heltec Vision Master E213",
    68: "Heltec Vision Master E290",
    69: "Heltec Mesh Node T114",
    70: "Sensecap Indicator",
    71: "Tracker T1000 E",
    72: "Rak3172",
    73: "Wio E5",
    74: "Radiomaster 900 Bandit",
    75: "Me25ls01 4y10td",
    76: "Rp2040 Feather Rfm95",
    77: "M5stack Corebasic",
    78: "M5stack Core2",
    79: "Rpi Pico2",
    80: "M5stack Cores3",
    81: "Seeed Xiao S3",
    82: "Ms24sf1",
    83: "Tlora C6",
    84: "Wismesh Tap",
    85: "Routastic",
    86: "Mesh Tab",
    87: "Meshlink",
    88: "Xiao Nrf52 Kit",
    89: "Thinknode M1",
    90: "Thinknode M2",
    91: "T Eth Elite",
    92: "Heltec Sensor Hub",
    93: "Muzi Base",
    94: "Heltec Mesh Pocket",
    95: "Seeed Solar Node",
    96: "Nomadstar Meteor Pro",
    97: "Crowpanel",
    98: "Link 32",
    99: "Seeed Wio Tracker L1",
    100: "Seeed Wio Tracker L1 Eink",
    101: "Muzi R1 Neo",
    102: "T Deck Pro",
    103: "T Lora Pager",
    104: "M5stack Reserved",
    105: "Wismesh Tag",
    106: "Rak3312",
    107: "Thinknode M5",
    108: "Heltec Mesh Solar",
    109: "T Echo Lite",
    110: "Heltec V4",
    111: "M5stack C6l",
    112: "M5stack Cardputer Adv",
    113: "Heltec Wireless Tracker V2",
    114: "T Watch Ultra",
    115: "Thinknode M3",
    116: "Wismesh Tap V2",
    117: "Rak3401",
    118: "Rak6421",
    119: "Thinknode M4",
    120: "Thinknode M6",
    121: "Meshstick 1262",
    122: "Tbeam 1 Watt",
    123: "T5 S3 Epaper Pro",
    124: "Tbeam Bpf",
    125: "Mini Epaper S3",
    126: "Tdisplay S3 Pro",
    127: "Heltec Mesh Node T096",
    128: "Mesh Tracker X1",
    129: "Thinknode M7",
    130: "Thinknode M8",
    131: "Thinknode M9",
    132: "Heltec V4 R8",
    133: "Heltec Mesh Node T1",
    134: "Station G3",
    135: "T Impulse Plus",
    136: "T Echo Card",
    137: "Seeed Wio Tracker L2",
    138: "Crowpanel P4",
    139: "Heltec Mesh Tower V2",
    140: "Meshnology W10",
    141: "Heltec Rc32",
    142: "Heltec Rc52",
    143: "Heltec Rcc6",
    144: "Seeed Wio Tracker L1 Pro 1w",
    145: "Meshnology W12",
    146: "Meshpager X2",
    255: "Private Hw",
};
export const ROLE_NAMES = {
    0: "Client",
    1: "Client Mute",
    2: "Router",
    3: "Router Client",
    4: "Repeater",
    5: "Tracker",
    6: "Sensor",
    7: "Tak",
    8: "Client Hidden",
    9: "Lost And Found",
    10: "Tak Tracker",
    11: "Router Late",
    12: "Client Base",
};
export const REGION_NAMES = {
    0: "Unset",
    1: "US",
    2: "EU / 433",
    3: "EU / 868",
    4: "CN",
    5: "JP",
    6: "ANZ",
    7: "KR",
    8: "TW",
    9: "RU",
    10: "IN",
    11: "NZ / 865",
    12: "TH",
    13: "LORA / 24",
    14: "UA / 433",
    15: "UA / 868",
    16: "MY / 433",
    17: "MY / 919",
    18: "SG / 923",
    19: "PH / 433",
    20: "PH / 868",
    21: "PH / 915",
    22: "ANZ / 433",
    23: "KZ / 433",
    24: "KZ / 863",
    25: "NP / 865",
    26: "BR / 902",
    27: "ITU1 / 2M",
    28: "ITU2 / 2M",
    29: "EU / 866",
    30: "EU / 874",
    31: "EU / 917",
    32: "EU / N / 868",
    33: "ITU3 / 2M",
    34: "ITU1 / 70CM",
    35: "ITU2 / 70CM",
    36: "ITU3 / 70CM",
    37: "ITU2 / 125CM",
};
export const HARDWARE_BY_PROTO_NAME = {
    "UNSET": 0,
    "TLORA_V2": 1,
    "TLORA_V1": 2,
    "TLORA_V2_1_1P6": 3,
    "TBEAM": 4,
    "HELTEC_V2_0": 5,
    "TBEAM_V0P7": 6,
    "T_ECHO": 7,
    "TLORA_V1_1P3": 8,
    "RAK4631": 9,
    "HELTEC_V2_1": 10,
    "HELTEC_V1": 11,
    "LILYGO_TBEAM_S3_CORE": 12,
    "RAK11200": 13,
    "NANO_G1": 14,
    "TLORA_V2_1_1P8": 15,
    "TLORA_T3_S3": 16,
    "NANO_G1_EXPLORER": 17,
    "NANO_G2_ULTRA": 18,
    "LORA_TYPE": 19,
    "WIPHONE": 20,
    "WIO_WM1110": 21,
    "RAK2560": 22,
    "HELTEC_HRU_3601": 23,
    "HELTEC_WIRELESS_BRIDGE": 24,
    "STATION_G1": 25,
    "RAK11310": 26,
    "MAKERFABS_TRACKER": 27,
    "MAKERFABS_RESERVED": 28,
    "CANARYONE": 29,
    "RP2040_LORA": 30,
    "STATION_G2": 31,
    "LORA_RELAY_V1": 32,
    "T_ECHO_PLUS": 33,
    "PPR": 34,
    "GENIEBLOCKS": 35,
    "NRF52_UNKNOWN": 36,
    "PORTDUINO": 37,
    "ANDROID_SIM": 38,
    "DIY_V1": 39,
    "NRF52840_PCA10059": 40,
    "DR_DEV": 41,
    "M5STACK": 42,
    "HELTEC_V3": 43,
    "HELTEC_WSL_V3": 44,
    "BETAFPV_2400_TX": 45,
    "BETAFPV_900_NANO_TX": 46,
    "RPI_PICO": 47,
    "HELTEC_WIRELESS_TRACKER": 48,
    "HELTEC_WIRELESS_PAPER": 49,
    "T_DECK": 50,
    "T_WATCH_S3": 51,
    "PICOMPUTER_S3": 52,
    "HELTEC_HT62": 53,
    "EBYTE_ESP32_S3": 54,
    "ESP32_S3_PICO": 55,
    "CHATTER_2": 56,
    "HELTEC_WIRELESS_PAPER_V1_0": 57,
    "HELTEC_WIRELESS_TRACKER_V1_0": 58,
    "UNPHONE": 59,
    "TD_LORAC": 60,
    "CDEBYTE_EORA_S3": 61,
    "TWC_MESH_V4": 62,
    "NRF52_PROMICRO_DIY": 63,
    "RADIOMASTER_900_BANDIT_NANO": 64,
    "HELTEC_CAPSULE_SENSOR_V3": 65,
    "HELTEC_VISION_MASTER_T190": 66,
    "HELTEC_VISION_MASTER_E213": 67,
    "HELTEC_VISION_MASTER_E290": 68,
    "HELTEC_MESH_NODE_T114": 69,
    "SENSECAP_INDICATOR": 70,
    "TRACKER_T1000_E": 71,
    "RAK3172": 72,
    "WIO_E5": 73,
    "RADIOMASTER_900_BANDIT": 74,
    "ME25LS01_4Y10TD": 75,
    "RP2040_FEATHER_RFM95": 76,
    "M5STACK_COREBASIC": 77,
    "M5STACK_CORE2": 78,
    "RPI_PICO2": 79,
    "M5STACK_CORES3": 80,
    "SEEED_XIAO_S3": 81,
    "MS24SF1": 82,
    "TLORA_C6": 83,
    "WISMESH_TAP": 84,
    "ROUTASTIC": 85,
    "MESH_TAB": 86,
    "MESHLINK": 87,
    "XIAO_NRF52_KIT": 88,
    "THINKNODE_M1": 89,
    "THINKNODE_M2": 90,
    "T_ETH_ELITE": 91,
    "HELTEC_SENSOR_HUB": 92,
    "MUZI_BASE": 93,
    "HELTEC_MESH_POCKET": 94,
    "SEEED_SOLAR_NODE": 95,
    "NOMADSTAR_METEOR_PRO": 96,
    "CROWPANEL": 97,
    "LINK_32": 98,
    "SEEED_WIO_TRACKER_L1": 99,
    "SEEED_WIO_TRACKER_L1_EINK": 100,
    "MUZI_R1_NEO": 101,
    "T_DECK_PRO": 102,
    "T_LORA_PAGER": 103,
    "M5STACK_RESERVED": 104,
    "WISMESH_TAG": 105,
    "RAK3312": 106,
    "THINKNODE_M5": 107,
    "HELTEC_MESH_SOLAR": 108,
    "T_ECHO_LITE": 109,
    "HELTEC_V4": 110,
    "M5STACK_C6L": 111,
    "M5STACK_CARDPUTER_ADV": 112,
    "HELTEC_WIRELESS_TRACKER_V2": 113,
    "T_WATCH_ULTRA": 114,
    "THINKNODE_M3": 115,
    "WISMESH_TAP_V2": 116,
    "RAK3401": 117,
    "RAK6421": 118,
    "THINKNODE_M4": 119,
    "THINKNODE_M6": 120,
    "MESHSTICK_1262": 121,
    "TBEAM_1_WATT": 122,
    "T5_S3_EPAPER_PRO": 123,
    "TBEAM_BPF": 124,
    "MINI_EPAPER_S3": 125,
    "TDISPLAY_S3_PRO": 126,
    "HELTEC_MESH_NODE_T096": 127,
    "MESH_TRACKER_X1": 128,
    "THINKNODE_M7": 129,
    "THINKNODE_M8": 130,
    "THINKNODE_M9": 131,
    "HELTEC_V4_R8": 132,
    "HELTEC_MESH_NODE_T1": 133,
    "STATION_G3": 134,
    "T_IMPULSE_PLUS": 135,
    "T_ECHO_CARD": 136,
    "SEEED_WIO_TRACKER_L2": 137,
    "CROWPANEL_P4": 138,
    "HELTEC_MESH_TOWER_V2": 139,
    "MESHNOLOGY_W10": 140,
    "HELTEC_RC32": 141,
    "HELTEC_RC52": 142,
    "HELTEC_RCC6": 143,
    "SEEED_WIO_TRACKER_L1_PRO_1W": 144,
    "MESHNOLOGY_W12": 145,
    "MESHPAGER_X2": 146,
    "PRIVATE_HW": 255,
};
export const ROLE_BY_PROTO_NAME = {
    "CLIENT": 0,
    "CLIENT_MUTE": 1,
    "ROUTER": 2,
    "ROUTER_CLIENT": 3,
    "REPEATER": 4,
    "TRACKER": 5,
    "SENSOR": 6,
    "TAK": 7,
    "CLIENT_HIDDEN": 8,
    "LOST_AND_FOUND": 9,
    "TAK_TRACKER": 10,
    "ROUTER_LATE": 11,
    "CLIENT_BASE": 12,
};
export const REGION_BY_PROTO_NAME = {
    "UNSET": 0,
    "US": 1,
    "EU_433": 2,
    "EU_868": 3,
    "CN": 4,
    "JP": 5,
    "ANZ": 6,
    "KR": 7,
    "TW": 8,
    "RU": 9,
    "IN": 10,
    "NZ_865": 11,
    "TH": 12,
    "LORA_24": 13,
    "UA_433": 14,
    "UA_868": 15,
    "MY_433": 16,
    "MY_919": 17,
    "SG_923": 18,
    "PH_433": 19,
    "PH_868": 20,
    "PH_915": 21,
    "ANZ_433": 22,
    "KZ_433": 23,
    "KZ_863": 24,
    "NP_865": 25,
    "BR_902": 26,
    "ITU1_2M": 27,
    "ITU2_2M": 28,
    "EU_866": 29,
    "EU_874": 30,
    "EU_917": 31,
    "EU_N_868": 32,
    "ITU3_2M": 33,
    "ITU1_70CM": 34,
    "ITU2_70CM": 35,
    "ITU3_70CM": 36,
    "ITU2_125CM": 37,
};
export function hardwareName(id) {
    if (id === null || id === undefined)
        return 'Unknown';
    return HARDWARE_NAMES[id] ?? `HW ${id}`;
}
export function roleName(id) {
    if (id === null || id === undefined)
        return '';
    return ROLE_NAMES[id] ?? `Role ${id}`;
}
export function regionName(id) {
    if (id === null || id === undefined || id === 0)
        return '';
    return REGION_NAMES[id] ?? `Region ${id}`;
}
/** Client-side nodes keep their position private by default. */
export function isHiddenRole(role) {
    return role === 8 || role === 9;
}
//# sourceMappingURL=enums.js.map